import React from "react";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useWallet } from "../context/walletContext";
import { formatAmount } from "../utils/formatAmount";
import MiniStatCard from "./ui/MiniStatCard";

const DashboardBoxes = () => {
  const { walletAmt } = useWallet();
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4 w-full">
      <MiniStatCard
        title="Main Wallet Balance"
        value={`₹ ${formatAmount(walletAmt?.main?.balance)}`}
        icon={<MonetizationOnOutlinedIcon fontSize="small" />}
      />
      <MiniStatCard
        title="Add Money Wallet Balance"
        value={`₹ ${formatAmount(walletAmt?.addMoney?.balance)}`}
        icon={<MonetizationOnOutlinedIcon fontSize="small" />}
      />
      <MiniStatCard
        title="AEPS Wallet Balance"
        value={`₹ ${formatAmount(walletAmt?.aeps?.balance)}`}
        icon={<MonetizationOnOutlinedIcon fontSize="small" />}
      />
    </div>
  );
};
export default DashboardBoxes;
